import createHistory from 'history/createBrowserHistory';

let debug = require('debug')('ro:history');
let history = createHistory();

const unlisten = history.listen((location, action) => {
    // location is an object like window.location
    debug(action, location.pathname, location.state);
})

export default history;


// WEBPACK FOOTER //
// ./src/components/history.js